<template>
  <div class="column">
    <div class="columns">
      <div class="column">
        <div v-if="initialValidation.fullTasks === null" style="height: 48px"
             class="is-flex is-align-items-center dashed-border-small ml-0 mr-0 mt-auto mb-auto">
          <h4 class="is-size-6 ml-auto mr-auto has-text-grey-light has-text-weight-light">{{ getMessage() }}</h4>
        </div>
        <div v-else style="height: 48px" class="is-flex mt-auto mb-auto">
          <b-tooltip type="is-dark" position="is-left" :delay="1000" multilined>
            <template v-slot:content>
              <div>
                <div>Stage #4 - Final Processing</div>
                <div>Click to view Auto Validation Review</div>
              </div>
            </template>
          <div class="clickable-info has-text-centered is-flex mr-1" style="height: 48px; width: 48px; background: #1e2b57;cursor: pointer;"
               @click="onShowInitialResults" >
            <div class="is-size-6 mt-auto mb-auto ml-auto mr-auto has-text-white">#4</div>
          </div>
          </b-tooltip>
          <hr class="has-background-grey-lighter m-0" style="width: 1px; height: 48px">
          <div class="clickable-info has-text-centered is-flex ml-1" style="height: 48px; width: 80px"
               :style="statusStyle()" @click="showError">
            <div class="is-size-7 mt-auto mb-auto ml-auto mr-auto has-text-white">{{ initialValidation.fullTasks.status }}</div>
          </div>
          <div class="clickable-info ml-2 is-flex pt-2 pl-4" style="flex-grow: 1">
            <div class="m-0" style="flex: 1;max-width: 48px" v-if="initialValidation.fullTasks.status !== 'CREATED'">
              <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px">VERSION</div>
              <div class="has-text-black has-text-weight-bold" style="line-height: 1">{{
                  initialValidation.fullTasks.version
                }}
              </div>
            </div>
            <div style="flex: 0.5" class="is-flex" v-if="initialValidation.fullTasks.status !== 'CREATED'">
              <hr class="mt-0 mb-1 ml-auto mr-auto has-background-grey-lighter" style="width: 1px; height: 30px">
            </div>
            <div class="m-0" style="flex: 1">
              <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px;">
                {{ initialValidation.fullTasks.status === 'CREATED' ? 'CREATED TASKS' : 'QUEUED' }}
              </div>
              <div class="has-text-black has-text-weight-bold" style="line-height: 1">
                {{
                  initialValidation.fullTasks.status === 'CREATED' ? initialValidation.fullTasks.created : initialValidation.fullTasks.queued
                }}
              </div>
            </div>
            <div class="m-0" style="flex: 1" v-if="initialValidation.fullTasks.status !== 'CREATED'">
              <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px">IN PROGRESS</div>
              <div class="has-text-black has-text-weight-bold" style="line-height: 1">{{
                  initialValidation.fullTasks.inProgress
                }}
              </div>
            </div>
            <div style="flex: 0.5" class="is-flex" v-if="initialValidation.fullTasks.status !== 'CREATED'">
              <hr class="mt-0 mb-1 ml-auto mr-auto has-background-grey-lighter" style="width: 1px; height: 30px">
            </div>
            <div class="m-0" style="flex: 1" v-if="initialValidation.fullTasks.status !== 'CREATED'">
              <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px">FAILED</div>
              <div class="has-text-black has-text-weight-bold" style="line-height: 1">{{
                  initialValidation.fullTasks.failed
                }}
              </div>
            </div>
            <div class="m-0" style="flex: 1" v-if="initialValidation.fullTasks.status !== 'CREATED'">
              <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px">COMPLETED</div>
              <div class="has-text-black has-text-weight-bold" style="line-height: 1">{{
                  initialValidation.fullTasks.completed
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-flex is-flex-direction-row" style="max-width: 100px">
        <view-guard :permission="'data-processing:create-tasks'" class="ml-auto mr-0 mt-auto mb-auto">
          <b-tooltip v-if="refreshing"
                     class="ml-auto mr-auto mt-auto mb-auto" label="Please Wait..." :delay="1000" type="is-dark" position="is-left">
            <div v-if="refreshing" class="my-loader mt-1 mb-1"></div>
          </b-tooltip>
          <b-tooltip v-if="initialValidation.fullTasks && initialValidation.fullTasks.status === 'COMPLETED' && !refreshing"
                     class="ml-auto mr-0 mt-auto mb-auto" label="Reset to step #1" :delay="1000" type="is-dark" position="is-left">
            <b-icon
                icon="close-circle"
                class="clickable" size="is-medium"
                style="color: rgba(30,43,87,0.4)"
                @click.native="onFullReset"></b-icon>
          </b-tooltip>
<!--          <b-tooltip v-if="initialValidation.fullTasks && initialValidation.fullTasks.status === 'COMPLETED' && !refreshing"
                     class="ml-2 mr-0 mt-auto mb-auto" label="Re Run Full Processing" :delay="1000" type="is-dark" position="is-left">
            <b-icon
                icon="restart"
                class="clickable" size="is-medium"
                style="color: #1e2b57"
                @click.native="onRunFullProcessing"></b-icon>
          </b-tooltip>-->
          <b-tooltip v-if="initialValidation.fullTasks && initialValidation.fullTasks.status === 'COMPLETED' && allConditions() && !refreshing"
                     class="ml-2 mr-0 mt-auto mb-auto" label="Go to QA Validation" :delay="1000" type="is-dark" position="is-left">
            <b-icon
                icon="arrow-right-bold-circle"
                class="clickable" size="is-medium"
                style="color: #1e2b57"
                @click.native="onShowFullResults"></b-icon>
          </b-tooltip>
          <b-tooltip v-if="initialValidation.fullTasks && initialValidation.fullTasks.status === 'FAILED' && !refreshing"
                     class="ml-0 mr-0 mt-auto mb-auto" :label="checkPermission() === false ? 'Please contact System Admin' : 'Revert Final Processing to step #3'" :delay="1000" type="is-dark" position="is-left">
            <b-button type="is-primary" @click="onResetStep" :disabled="checkPermission() === false" style="background-color: #1e2b57">Revert</b-button>
          </b-tooltip>
          <b-tooltip v-if="initialValidation.fullTasks && initialValidation.fullTasks.status === 'COMPLETED' && !allConditions() && !refreshing"
                     class="ml-2 mr-0 mt-auto mb-auto" label="Final Results Not Available" :delay="1000" type="is-dark" position="is-left">
            <b-icon
                icon="chart-line" size="is-medium"
                style="color: rgba(30,43,87,0.11)"></b-icon>
          </b-tooltip>
          <b-tooltip v-else-if="initialValidation.fullTasks && initialValidation.fullTasks.status === 'RUNNING' && !refreshing"
                     class="ml-auto mr-auto mt-auto mb-auto" label="Please Wait..." :delay="1000" type="is-dark" position="is-left">
            <b-icon
                icon="progress-clock"
                class="clickable" size="is-medium"></b-icon>

            <b-progress size="is-small" :value="progressValue"></b-progress>
          </b-tooltip>
        </view-guard>
      </div>
    </div>
  </div>
</template>

<script>
import ViewGuard from "@/components/view-guard/view-guard.vue";
import {isAllowed} from "@/utils/utils";

export default {
  name: "full-validation-info",
  components: {ViewGuard},
  props: {
    initialValidation: {
      type: Object
    },
    refreshing: {
      type: Boolean
    }
  },
  data(){
    return {
      progressValue:40,
      //refreshing: false
    }
  },
  methods: {
    isAllowed,
    setProgress(progress){
      this.progressValue = progress
    },
    showError(){
      this.$emit('onShowError', this.initialValidation.fullTasks.errors)
    },
/*    setRefreshing(refresh){
      this.refreshing = refresh
    },*/
    getMessage() {
      if (this.allConditions()) {
        return 'This device has no tasks'
      } else {
        return 'Conditions missing'
      }
    },
    checkPermission() {
      return isAllowed(this.$store.getters.getMe, 'data-processing:reset-step')
    },
    statusStyle() {
      if (this.initialValidation.fullTasks && this.initialValidation.fullTasks.status) {
        if (this.initialValidation.fullTasks.status === 'CREATED') {
          return {background: '#8C84FF'}
        } else if (this.initialValidation.fullTasks.status === 'RUNNING') {
          return {background: '#D8BA13'}
        } else if (this.initialValidation.fullTasks.status === 'COMPLETED') {
          return {background: '#1CAB80'}
        }else if (this.initialValidation.fullTasks.status === 'FAILED') {
          if(this.initialValidation.fullTasks.errors && this.initialValidation.fullTasks.errors.length > 0){
            return {background: '#e02c2c', cursor: 'pointer'}
          }else{
            return {background: '#e02c2c'}
          }
        }
      }
      return {background: '#000000'}
    },
    allConditions() {
      if(this.initialValidation.fullChart && this.initialValidation.fullChart._id){
        return true
      }
      return false
    },
    initialConditions(){
      if(this.initialValidation.validationChart && this.initialValidation.validationChart._id){
        return true
      }
      return false
    },
    onShowFullResults() {
      console.log('On Show full results:', this.initialValidation)
      this.$emit('onShowFullResults')
    },
    onShowInitialResults() {
      console.log('On Show initial results:', this.initialValidation)
      this.$emit('onShowInitialResults')
    },
    onRunFullProcessing(){
      this.$emit('onRunFullProcessing')
    },
    onResetStep(){
      this.$emit('onResetStep', 'final')
    },
    onFullReset(){
      this.$emit('onResetStep', 'full')
    }
  }
}
</script>

<style scoped lang="scss">

.tooltip-content {
  white-space: pre-line !important;
}
.dashed-border-small {
  padding: 8px 8px;
  border-style: dashed;
  border-radius: 8px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.1);
}

.clickable-info {
  background: #f4f4f4;
  border-radius: 0.3rem;
}

/*.clickable-info:hover {
  cursor: pointer;
}*/

.clickable:hover {
  cursor: pointer;
}

.dashed-border-small {
  padding: 8px 8px;
  border-style: dashed;
  border-radius: 8px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.1);
}

.my-loader {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #1cab80;
  border-bottom: 4px solid #1cab80;
  width: 30px;
  height: 30px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>